import React, { useMemo } from "react";
import CustomButton from "components/common/Button/CustomButton";
import { PaDataTable, PaEmptyState, PaStatusBadge } from "components/platform-admin";
import { platformRoleAccess } from "helpers/RolesPermission";
import { formatUserTypeLabel, mergeTenantUsers } from "./tenantDetail.utils";

const TenantUsersTab = ({ tenant, createdUsers, onAddUser }) => {
  const canCreateUsers = platformRoleAccess("platform.tenant.users.create");

  const ownerRow = tenant?.owner
    ? {
        id: tenant.owner.id,
        name: tenant.owner.name,
        email: tenant.owner.email,
        user_type: "sp_admin",
        status: true,
        isOwner: true,
      }
    : null;

  const tableRows = useMemo(
    () => mergeTenantUsers(ownerRow, createdUsers),
    [ownerRow, createdUsers]
  );

  const columns = [
    {
      key: "name",
      label: "Name",
      render: (row) => (
        <div>
          <div className="font-medium text-gray-900">{row.name || "—"}</div>
          {row.isOwner ? (
            <div className="text-xs text-gray-500">Tenant owner</div>
          ) : null}
        </div>
      ),
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "user_type",
      label: "Type",
      render: (row) => (
        <PaStatusBadge label={formatUserTypeLabel(row.user_type)} variant="info" />
      ),
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <PaStatusBadge
          label={row.status ? "Active" : "Inactive"}
          variant={row.status ? "success" : "neutral"}
        />
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-gray-500">
          Tenant owner and users created in this session. Full tenant user directory
          listing is not yet available via API.
        </p>
        {canCreateUsers ? (
          <CustomButton
            label="Add user"
            clickHandler={onAddUser}
            cssClass="bg-indigo-600 hover:bg-indigo-700 text-white"
          />
        ) : null}
      </div>

      <PaDataTable
        columns={columns}
        rows={tableRows}
        rowKey="id"
        emptyState={
          <PaEmptyState
            title="No users yet"
            message="Add a tenant user to see them here"
          />
        }
      />
    </div>
  );
};

export default TenantUsersTab;
